<template>
  <div class="ratings-page-header">
    <BasicSection appearance="heading">
      <div class="ratings-page-header__main">
        <div class="ratings-page-header__title-wrapper">
          <div class="ratings-page-header__title">
            <PageTitle title="Рейтинг компаний" />
          </div>
          <BasicButton class="mq-mobile-only" :href="helpHref">
            <SvgIcon icon="info" size="20" color="muted" />
          </BasicButton>
        </div>
        <div class="ratings-page-header__period-switch">
          <BasicSelect
            v-model="periodModel"
            :options="periodOptions"
          />
        </div>
        <div
          v-if="rateHref"
          class="ratings-page-header__rate-button"
        >
          <BasicButton
            appearance="rate"
            :href="rateHref"
            size="l"
            target="_blank"
          >
            Оценить свою компанию
          </BasicButton>
        </div>
      </div>
      <div class="ratings-page-header__tabs-wrapper">
        <span>
          Сотрудников:
        </span>
        <div class="ratings-page-header__tabs">
          <BasicTabs
            v-model="tabModel"
            :tabs="tabOptions"
            appearance="primary"
            underline
            underline-containment="tabs"
          />
        </div>
      </div>
    </BasicSection>
  </div>
</template>

<script>
  import { createPropModel } from 'src/utils/vue.js';

  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import BasicSelect from 'src/components/form/BasicSelect/BasicSelect.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import PageTitle from 'src/components/PageTitle/PageTitle.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  import BasicTabs from 'src/components/tabs/BasicTabs/BasicTabs.vue';

  export default {
    name: 'RatingsPageHeader',
    components: { BasicSection, BasicTabs, BasicButton, SvgIcon, BasicSelect, PageTitle },
    props: {
      period: {
        type: String,
        required: true,
      },
      periodOptions: {
        type: Array,
        required: true,
      },
      tab: {
        type: [String, Number],
        required: true,
      },
      tabOptions: {
        type: Array,
        required: true,
      },
      rateHref: String,
      helpHref: {
        type: String,
        required: true,
      },
    },
    computed: {
      tabModel: createPropModel('tab'),
      periodModel: createPropModel('period'),
    }
  }
</script>